import React from 'react'

import ProductTag from 'components/product/ProductTag/ProductTag'

import s from './Tags.scss'


const ProductDetailsModalTags = ({ items, lightGray }) => {
  const areItemsExist = Boolean(items && items.length)

  return areItemsExist && (
    <div className={s.tags}>
      {
        // There is cologne with id: 609 where is empty {} tag, so filter it
        items.filter(({ name }) => name).map(({ name, img }, index) => (
          <div key={index} className={s.tagContainer}>
            <ProductTag
              className={s.tag}
              tagClassName={s.tagIcon}
              name={name}
              img={img}
              lightGray={lightGray}
              withTitle
            />
          </div>
        ))
      }
    </div>
  )
}


export default ProductDetailsModalTags
